<template>
  <div id="app" v-if="src">
    <iframe :src="src" id="custom-iframe" frameborder="0"></iframe>
  </div>
</template>

<script>
import cookie from 'js-cookie'
export default {
  name: 'App',
  data () {
    return {
      src: '',
      loginPageUrl: '',
      guidesInfo: {
        // 'tpc': 'https://summer92-82.tvunetworks.com/#/tpc/home-0',
        // 'userActivity': 'https://summer92-86.tvunetworks.com/#/home/',
        // 'home': 'https://summer92-82.tvunetworks.com/#/tpc/home-0',
        'home':  'https://www.tvunetworks.com/tvu-products-tips/', 
        'producer': 'https://www.tvunetworks.com/tvu-products-tips/tvu-producer-2/ ',
        'anywhere': 'https://www.tvunetworks.com/tvu-products-tips-anywhere/ ',
        'search': 'https://www.tvunetworks.com/tvu-search-products-tips/  ',
        'partyline': 'https://www.tvunetworks.com/tvu-products-tips-partyline/ ',
        'tvuOne': 'https://www.tvunetworks.com/tvu-products-tips-one/ ',
        'channel': 'https://www.tvunetworks.com/tvu-channel-products-tips/',
        'user': 'https://www.tvunetworks.com/tvu-products-user-guides/'
      }
    }
  },
  async mounted() {
    console.info(188888)
    const _this = this
    window.onhashchange = function() {
      console.log('当前的URL hash变化了。新的hash是:', window.location.hash);
      // 在这里可以添加你需要执行的代码，比如根据新的hash值进行页面的跳转或内容的更新等
      sessionStorage.setItem('hash', window.location.hash.split('#/')[1])
      _this.checkLogin()
    };
    await this.getInitConfig()
    this.checkLogin()
  },
  methods: {
    checkLogin () {
      this.$axios.get('/userAuth/main/checkUserAuth', {
        params: {
          session: cookie.get('SID') || '',
          serviceName: 'USER GUIDES / FAQ'
        }
      }).then(res=>{
        const { errorCode } = res.data
        const hash = window.location.hash.split('#/')[1] || sessionStorage.getItem('hash')
        // const sessionHash = sessionStorage.getItem('hash')

        if (errorCode == '0x0') {
          const origin = window.location.href.split('origin=')[1] || 'https://www.tvunetworks.com'
          // this.src = `${origin}/tvu-products-user-guides`
          // if (!hash && sessionHash) {
          //   console.info(111111111111111)
          //   sessionStorage.removeItem('hash')
          //   window.location.href = `${location.origin}/#/${sessionHash}`
          // } else { 
            this.src = this.guidesInfo[hash] || `${origin}/tvu-products-user-guides`//'https://summer92-82.tvunetworks.com'
          // }

          
        }
        if (errorCode == '0x80060005') {
          sessionStorage.setItem('hash', hash)
          window.location.href = `${this.loginPageUrl}/?url=${location.protocol}//${location.host}&serviceName=${encodeURIComponent('USER GUIDES / FAQ')}`
        }
        // if(errorCode == '0x80060005') {
        //   window.location.href = `${this.loginPageUrl}/?url=${location.protocol}//${location.host}&serviceName=${encodeURIComponent('USER GUIDES / FAQ')}`
        // }
      })
    },
    async getInitConfig () {
      await this.$axios.get('/login-service/init/initConfig').then(res=>{
        const { errorCode, result } = res.data
        if (errorCode == '0x0') {
          this.loginPageUrl = result.loginPageUrl
        }
      })
    }
  }
}

</script>
<style>
body {
  margin: 0;
}
#app, #custom-iframe {
  width: 100vw;
  height: 100vh;
  vertical-align: top;
}
</style>
